import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { useApi } from '@/lib/api-context';

import type { FieldValue } from './presentation';

// Completar los campos propios de un documento (QA F1 #14). Cada cambio refresca la
// ficha y la Lista Maestra (columnas de campos propios), también tras un rechazo:
// otro usuario pudo cambiar los datos o las definiciones al mismo tiempo.

const BASE = '/api/v1/quality/master-list';

export function useFillCustomFields(
  entryId: string,
): UseMutationResult<void, Error, Record<string, FieldValue | null>> {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (values) => {
      await api.patch(`${BASE}/${entryId}/custom-fields`, { values });
    },
    onSettled: async () => {
      await Promise.all([
        qc.invalidateQueries({ queryKey: ['dossier'] }),
        qc.invalidateQueries({ queryKey: ['master-list'] }),
      ]);
    },
  });
}
